import { gambits } from '@/core/gambits';
import { clearHandoffCookie, readHandoffCookie } from '@/core/helpers/handoff-cookie.helper';
import { createLogger } from '@/core/helpers/logger.helper';

const logger = createLogger('InstallHandoff');

/**
 * Kept synchronous so start-up only waits on the network for the rare launch
 * that actually has a code to spend.
 */
export function hasPendingHandoff(): boolean {
  return !gambits.authService.isAuthenticated() && !!readHandoffCookie();
}

/**
 * iOS gives a home screen web app its own storage, so a fresh install starts
 * signed out even when Safari is signed in. It does copy cookies across at
 * install time, so the first launch spends the code parked in one.
 */
export async function redeemInstallHandoff(): Promise<void> {
  const parked = readHandoffCookie();
  if (!parked) return;

  const result = await gambits.authService.getToken(parked.code);
  if (result.error) {
    // Deliberately left in place. A first launch is exactly when the network is
    // most likely to be cold, and dropping it here would turn one flaky request
    // into a permanent sign-out. A spent code just fails again until the cookie
    // reaches the expiry the server gave it, and an authenticated launch skips
    // this path entirely.
    logger.warn(`Hand-off code could not be redeemed, falling back to sign in: ${result.error.message}`);
    return;
  }

  clearHandoffCookie();
}
